<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="180px" :model="form" disabled>
      <el-tabs v-model="activeName">
        <el-tab-pane label="驳回单信息" name="first">
          <el-form-item label="机构" style="margin-right:15px">
            <el-select v-model="form.orderDetailRefund.branchCode">
              <el-option v-for="item in dicts.branchList" :key="item.code" :label="item.groupName" :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="运单code" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.orderDetailCode" />
          </el-form-item> -->
          <el-form-item label="运输单号" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.orderDetailNumber" />
          </el-form-item>
          <el-form-item label="支付方式" style="margin-right:15px">
            <el-select v-model="form.orderDetailRefund.payType">
              <el-option v-for="item in dicts.payTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="退款金额(元)" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.amount" />
          </el-form-item>
          <!-- <el-form-item label="收款方code" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.partyCode" />
          </el-form-item> -->
          <el-form-item label="收款方姓名" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.partyName" />
          </el-form-item>
          <el-form-item label="收款方手机号" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.partyPhone" />
          </el-form-item>
          <el-form-item label="状态" style="margin-right:15px">
            <el-select v-model="form.orderDetailRefund.status">
              <el-option v-for="item in dicts.statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select> 
          </el-form-item>
          <el-form-item label="描述" style="margin-right:15px">
            <el-input v-model="form.orderDetailRefund.info" />
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane v-if="form.orderShareRefund" label="分账退回信息" name="second">
          <!-- <el-form-item label="分账表code" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.relatedCode" />
          </el-form-item> -->
          <el-form-item label="原支付订单收款商户号" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.merchantId" />
          </el-form-item>
          <el-form-item label="原支付订单号" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.relateOrderNo" />
          </el-form-item>
          <el-form-item label="外部订单分账请求流水号" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.outTradeNo" />
          </el-form-item>
          <el-form-item label="网商分账退回订单号" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.shareRefundOrderNo" />
          </el-form-item>
          <el-form-item label="订单分账金额(分)" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.totalAmount" />
          </el-form-item>
          <el-form-item label="状态" style="margin-right:15px">
            <el-select v-model="form.orderShareRefund.status">
              <el-option v-for="item in dicts.statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="分账退回时间" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.shareRefundDate" />
          </el-form-item>
          <el-form-item label="分账退回原因" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.reason" />
          </el-form-item>
          <el-form-item label="扩展信息" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.extInfo" />
          </el-form-item>
          <el-form-item label="备注" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.memo" />
          </el-form-item>
          <el-form-item label="错误码" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.errorCode" />
          </el-form-item>
          <el-form-item label="错误描述" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.errorDesc" />
          </el-form-item>
          <!-- <el-form-item label="收款方code" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.partyCode" />
          </el-form-item> -->
          <el-form-item label="收款方姓名" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.partyName" />
          </el-form-item>
          <el-form-item label="收款方手机号" style="margin-right:15px">
            <el-input v-model="form.orderShareRefund.partyPhone" />
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane v-if="form.payRefund" label="支付退回信息" name="third">
          <!-- <el-form-item label="余额支付code" style="margin-right:15px">
            <el-input v-model="form.payRefund.elatedCode" />
          </el-form-item> -->
          <el-form-item label="退款付方类型" style="margin-right:15px">
            <el-select v-model="form.payRefund.participantType">
              <el-option v-for="item in dicts.participantTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
                  
          </el-form-item>
          <el-form-item label="退款付方id" style="margin-right:15px">
            <el-input v-model="form.payRefund.participantId" />
          </el-form-item>
          <el-form-item label="原支付订单号" style="margin-right:15px">
            <el-input v-model="form.payRefund.relateOrderNo" />
          </el-form-item>
          <el-form-item label="关联网商支付流水号" style="margin-right:15px">
            <el-input v-model="form.payRefund.relateTransNo" />
          </el-form-item>
          <el-form-item label="退款外部交易号" style="margin-right:15px">
            <el-input v-model="form.payRefund.outRefundNo" />
          </el-form-item>
          <el-form-item label="订单退款金额(分)" style="margin-right:15px">
            <el-input v-model="form.payRefund.refundAmount" />
          </el-form-item>
          <el-form-item label="退款原因" style="margin-right:15px">
            <el-input v-model="form.payRefund.refundReason" />
          </el-form-item>
          <el-form-item label="状态" style="margin-right:15px">
            <el-select v-model="form.payRefund.status">
              <el-option v-for="item in dicts.statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="退款网商订单号" style="margin-right:15px">
            <el-input v-model="form.payRefund.refundOrderNo" />
          </el-form-item>
          <el-form-item label="退款完成时间" style="margin-right:15px">
            <el-input v-model="form.payRefund.refundFinishDate" />
          </el-form-item>
          <el-form-item label="渠道退款单号（聚合 ）" style="margin-right:15px">
            <el-input v-model="form.payRefund.channelRefundOrderNo" />
          </el-form-item>
          <el-form-item label="商户实际退款金额" style="margin-right:15px">
            <el-input v-model="form.payRefund.participantActualRefundAmount" />
          </el-form-item>
          <el-form-item label="扩展信息" style="margin-right:15px">
            <el-input v-model="form.payRefund.extInfo" />
          </el-form-item>
          <el-form-item label="备注" style="margin-right:15px">
            <el-input v-model="form.payRefund.memo" />
          </el-form-item>
          <el-form-item label="错误码" style="margin-right:15px">
            <el-input v-model="form.payRefund.errorCode" />
          </el-form-item>
          <el-form-item label="错误描述" style="margin-right:15px">
            <el-input v-model="form.payRefund.errorDesc" />
          </el-form-item>
          <!-- <el-form-item label="收款方code" style="margin-right:15px">
            <el-input v-model="form.payRefund.partyCode" />
          </el-form-item> -->
          <el-form-item label="收款方姓名" style="margin-right:15px">
            <el-input v-model="form.payRefund.partyName" />
          </el-form-item>
          <el-form-item label="收款方手机号" style="margin-right:15px">
            <el-input v-model="form.payRefund.partyPhone" />
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'OrderDetailRefundDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        orderDetailRefund:{
          code: '',
          orderDetailCode: '',
          orderDetailNumber: '',
          payType: '',
          amount: '',
          partyCode: '',
          partyName: '',
          partyPhone: '',
          status: '',
          info: '',
          branchCode: ''
        }
      },
      dicts:{},
      activeName: 'first'
    }
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code,dicts) {
      this.activeName = 'first'
      this.dicts = dicts
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({
        url: `/ntocc-tms-api/orderDetailRefund/${code}`,
        method: 'get'
      }).then((response) => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
